import { Section, PrimaryButton } from "@/components/Section";
import { SEO } from "@/components/SEO";
import { process as steps } from "@/config/site";

export default function ProcessPage() {
    return (
        <>
            <SEO title="Proces – Szymkas Agency" description="Od pomysłu do publikacji — jasno i krok po kroku. Siedem etapów współpracy." />
            <section className="bg-[#06111F] text-white pt-32 pb-16 md:pt-40 md:pb-20 relative overflow-hidden">
                <div className="absolute inset-0 bg-grid-faint opacity-50" />
                <div className="relative max-w-4xl mx-auto px-5 md:px-8 text-center">
                    <div className="text-xs font-semibold tracking-widest uppercase text-[#14B8A6] mb-3">Proces</div>
                    <h1 className="font-display font-extrabold text-[38px] md:text-[58px] lg:text-[64px] leading-[1.05] tracking-tight">
                        Od pomysłu do publikacji —<br /><span className="text-[#14B8A6]">jasno i krok po kroku</span>
                    </h1>
                </div>
            </section>
            <Section variant="light">
                <ol className="border-l-2 border-[#14B8A6]/30 pl-8 md:pl-12 space-y-10 max-w-3xl mx-auto">
                    {steps.map((s) => (
                        <li key={s.n} className="relative" data-testid={`process-page-step-${s.n}`}>
                            <span className="absolute -left-[44px] md:-left-[60px] w-12 h-12 rounded-full bg-white border-2 border-[#14B8A6] text-[#14B8A6] font-display font-bold text-lg flex items-center justify-center">
                                {s.n}
                            </span>
                            <h2 className="font-display font-bold text-xl md:text-2xl text-[#0B1220]">{s.title}</h2>
                            <p className="mt-2 text-[#0B1220]/75 text-base md:text-lg leading-relaxed">{s.desc}</p>
                        </li>
                    ))}
                </ol>
                <div className="mt-16 text-center">
                    <PrimaryButton to="/kontakt" testid="process-cta">Umów konsultację</PrimaryButton>
                </div>
            </Section>
        </>
    );
}
